module.exports = __webpack_public_path__ + "static/img/popup-bg.b293400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/popup-bg.png
// module id = 9wUu
// module chunks = 1